import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { CircleUserRound, ImageOff } from "lucide-react";
import { LoadImage } from "../../../../components/Loaders/LoadImage";
import { TypeUsersProp } from "@/pages/Units/Users";
import { ShowBtn } from "@/components/Show";
import { DeleteBtn } from "@/components/Delete";
import Grid from "@/components/Grid";
import { CreateLoaderInput } from "@/components/Loaders";
import { UpdateUserTenantBtn } from "../Update";
import {
  deleteUserUnities,
  getShowUserTenant,
  getUsersTenantData,
  setStatusUserUnities,
} from "@/Api/unities";
import { ComponentSwitchToggleStatus } from "@/App/Courses/ActivedOrDisabled";
import { TypeUser } from "@/types/userType";

export const ComponentTableUsers = ({ dataApi, updateFront, uuidUnit }) => {
  return (
    <>
      <Table className="bg-zinc-50 rounded shadow dark:bg-[#2c2c2c]">
        <TableHeader>
          <TableRow>
            <TableHead>Foto</TableHead>
            <TableHead>Nome</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Tipo de Usuário</TableHead>
            <TableHead className="text-center">Ativo</TableHead>
            <TableHead className="text-center">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dataApi?.map((user: TypeUsersProp) => (
            <TableRow key={user?.id}>
              <TableCell>
                {user?.user?.photo ? (
                  <LoadImage
                    src={user?.user?.photo}
                    className="size-7 aspect-square object-cover rounded"
                  />
                ) : (
                  <CircleUserRound
                    strokeWidth={1.5}
                    className="text-slate-700 size-7 dark:text-[#F4F4F5]"
                  />
                )}
              </TableCell>
              <TableCell>{user?.user?.name}</TableCell>
              <TableCell>{user?.user?.email}</TableCell>
              <TableCell>
                {user?.user?.user_type_id === TypeUser.admin && "Administrador"}
                {user?.user?.user_type_id === TypeUser.client && "Administrador"}
                {user?.user?.user_type_id === TypeUser.seller && "Vendedor"}
                {user?.user?.user_type_id === TypeUser.unity_responsible &&
                  "Usuário de unidade"}
                {user?.user?.user_type_id === TypeUser.stockist &&
                  "Estoquista"}
              </TableCell>
              <TableCell>
                <ComponentSwitchToggleStatus
                  defaultChecked={user?.user?.is_active ? true : false}
                  params={{
                    func: (params) =>
                      setStatusUserUnities(params.uuidUnit, params.uuidUser),
                    funcParams: {
                      uuidUnit,
                      uuidUser: user?.user?.uuid,
                    },
                  }}
                  updateFront={async () => {
                    const { data: refreshData } = await getUsersTenantData(
                      uuidUnit
                    );
                    updateFront(refreshData?.response);
                  }}
                />
              </TableCell>
              <TableCell className="flex justify-center">
                <div className="flex gap-3 w-full justify-center">
                  <UpdateUserTenantBtn
                    uuid={user?.user?.uuid}
                    uuidUnit={uuidUnit}
                    updateFront={updateFront}
                  />
                  <DeleteBtn
                    params={{
                      func: (params) =>
                        deleteUserUnities(params.tenant_uuid, params.user_uuid),
                      funcParams: {
                        tenant_uuid: uuidUnit,
                        user_uuid: user?.user?.uuid,
                      },
                    }}
                    updateFront={async () => {
                      const { data: refreshData } = await getUsersTenantData(
                        uuidUnit
                      );
                      updateFront(refreshData?.response);
                    }}
                    referenceLabel={`o usuário ${user?.user?.name}`}
                  />
                  <ShowBtn
                    labels={{ title: "Visualizar Usuário" }}
                    params={{
                      func: (params) =>
                        getShowUserTenant(params.uuidUnit, params.uuidUser),
                      funcParams: {
                        uuidUnit,
                        uuidUser: user?.user?.uuid,
                      },
                    }}
                    render={(responseApi: TypeUsersProp) => (
                      <div className="w-full h-auto">
                        <div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
                          <div className="flex flex-col items-center justify-between">
                            {responseApi?.user?.photo ? (
                              <LoadImage
                                src={responseApi?.user?.photo}
                                className="aspect-square object-cover size-36 rounded self-start"
                                iconSize={50}
                              />
                            ) : (
                              <ImageOff className="size-16 text-stone-300 flex-1" />
                            )}
                          </div>
                          <div className="flex flex-col gap-5">
                            <Grid.Item name="Nome" flex={0}>
                              {responseApi?.user?.name}
                            </Grid.Item>
                            <Grid.Item name="E-mail" flex={0}>
                              {responseApi?.user?.email}
                            </Grid.Item>
                          </div>
                        </div>
                      </div>
                    )}
                    loader={<CreateLoaderInput lines={4} />}
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
          {dataApi?.data?.length < 1 && (
            <TableRow>
              <TableCell colSpan={5}>Nada foi encontrado.</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  );
};
